import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ShuffleIcon = React.forwardRef(function ShuffleIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4 1.2C18.8418 0.868627 19.4686 0.95817 19.8 1.4L23.25 6L19.8 10.6C19.4686 11.0418 18.8418 11.1314 18.4 10.8C17.9582 10.4686 17.8686 9.84183 18.2 9.4L20.75 6L18.2 2.6C17.8686 2.15817 17.9582 1.53137 18.4 1.2Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 6C16 5.44772 16.4477 5 17 5H22C22.5523 5 23 5.44772 23 6 23 6.55228 22.5523 7 22 7H17C16.4477 7 16 6.55228 16 6ZM18.4 13.2C18.8418 12.8686 19.4686 12.9582 19.8 13.4L23.25 18 19.8 22.6C19.4686 23.0418 18.8418 23.1314 18.4 22.8 17.9582 22.4686 17.8686 21.8418 18.2 21.4L20.75 18 18.2 14.6C17.8686 14.1582 17.9582 13.5314 18.4 13.2ZM1 18C1 17.4477 1.44772 17 2 17H5C5.55228 17 6 17.4477 6 18 6 18.5523 5.55228 19 5 19H2C1.44772 19 1 18.5523 1 18Z"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 7C16.1376 7 15.2887 7.34828 14.9163 8.20046 14.6951 8.70653 14.1056 8.93748 13.5995 8.71631 13.0935 8.49514 12.8625 7.9056 13.0837 7.39954 13.8912 5.55172 15.6824 5 17 5 17.5523 5 18 5.44772 18 6 18 6.55228 17.5523 7 17 7ZM1 6C1 5.44772 1.44772 5 2 5H5C7.102 5 8.55878 5.92841 9.62022 7.24833 10.6137 8.48369 11.2825 10.0925 11.8832 11.5374 11.8941 11.5637 11.905 11.5899 11.9158 11.616 12.5539 13.1504 13.1264 14.5054 13.9262 15.4973 14.6762 16.4273 15.5958 17 17 17H22C22.5523 17 23 17.4477 23 18 23 18.5523 22.5523 19 22 19H17C14.8942 19 13.4338 18.0727 12.3694 16.7527 11.3705 15.514 10.6995 13.9001 10.0973 12.4517L10.0691 12.384C9.43084 10.8489 8.85954 9.49386 8.06166 8.50167 7.31372 7.57159 6.398 7 5 7H2C1.44772 7 1 6.55228 1 6ZM8.36212 15.0679C8.87692 15.2679 9.13213 15.8473 8.93213 16.3621 8.21662 18.2039 6.57536 19 5 19 4.44772 19 4 18.5523 4 18 4 17.4477 4.44772 17 5 17 5.90464 17 6.70338 16.5761 7.06787 15.6379 7.26786 15.1231 7.84732 14.8679 8.36212 15.0679Z"
      ></path>
    </svg>
  )
})

ShuffleIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ShuffleIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ShuffleIcon
